import { InputHTMLAttributes, ReactNode, forwardRef, useState } from "react";
import { Label } from "./Text/Text";
import { cn } from "@/lib/utils";
import { EyeIcon, EyeOffIcon } from "lucide-react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  errors?: string;
  left?: ReactNode;
  right?: ReactNode;
}

const PasswordInput = forwardRef<HTMLInputElement, Props>(
  ({ label, errors, className, left, ...rest }, ref) => {
    const [show, setShow] = useState(false);
    return (
      <div className="grid gap-1 w-full">
        <Label>{label}</Label>
        <div className="border border-gray-200 bg-[#F6F8FF] rounded-xl w-full flex gap-3">
          {left && <div className="w-auto rounded-xl ">{left}</div>}
          <input
            type={show ? "text" : "password"}
            ref={ref}
            {...rest}
            className={cn(
              "focus:outline-none border-0 bg-[#F6F8FF] rounded-xl  w-full py-3 md:py-4  disabled:cursor-not-allowed px-3",
              className
            )}
          />
          <div className="w-auto rounded-xl h-full flex items-center pr-3 cursor-pointer ">
            {show ? (
              <EyeIcon
                className="h-5 w-5 text-gray-500"
                onClick={() => setShow(!show)}
              />
            ) : (
              <EyeOffIcon
                className="h-5 w-5 text-gray-500"
                onClick={() => setShow(!show)}
              />
            )}
          </div>
        </div>
        <span className="text-red-500 text-xs font-medium">{errors}</span>
      </div>
    );
  }
);

export default PasswordInput;
